<template>
  <PageTitle pageTitle="Colaboradores" mainTitle="Colaboradores" />

  <v-card class="mb-25 pingo-card">
    <div class="v-card-header d-flex">
      <h5 class="mb-2">Lista de Colaboradores</h5>

      <router-link
        class="default-btn pingo small"
        :to="{ name: 'NewUserPage', query: { type: 'COLLABORATOR' } }"
      >
        <i class="ri-add-fill"></i>
        Criar novo colaborador
      </router-link>

      <!-- <p>Atualizado por último em {{ new Date().toLocaleString() }}</p> -->
    </div>

    <div class="pingo-table-content">
      <div class="v-elevation-z8 recentOrdersTable pingo-table">
        <v-data-table
          :headers="columns"
          :items="users"
          :loading="isLoadingUserCollaborators"
          :items-per-page="pagination.totalPerPage"
          hide-default-footer
        >
          <template v-slot:[`item.isActive`]="{ value }">
            <span
              v-if="value"
              class="text-capitalize badge rounded-pill text-soft-success"
            >
              Ativo
            </span>

            <span
              v-if="!value"
              class="text-capitalize badge rounded-pill text-soft-danger"
            >
              Inativo
            </span>
          </template>

          <template v-slot:[`item.actions`]="{ item }">
            <div class="d-flex align-items-center ga-6" style="width: 150px">
              <router-link
                v-if="user.type == 'ADMIN'"
                :to="{
                  name: 'EditUserPage',
                  params: { id: item.userId },
                  query: { type: 'COLLABORATOR' },
                }"
              >
                <v-btn
                  class="text-capitalize"
                  color="primary-darken-3"
                  variant="tonal"
                >
                  Editar
                </v-btn>
              </router-link>

              <v-dialog width="auto" scrollable>
                <template v-slot:activator="{ props: activatorProps }">
                  <v-btn
                    class="text-capitalize"
                    color="red-darken-3"
                    variant="tonal"
                    v-bind="activatorProps"
                  >
                    Remover
                  </v-btn>
                </template>

                <template v-slot:default="{ isActive }">
                  <v-card class="py-0" title="Remover colaborador">
                    <v-divider></v-divider>

                    <v-card-text class="px-4">
                      Tem certeza que deseja remover este colaborador?
                    </v-card-text>

                    <v-divider></v-divider>

                    <v-card-actions>
                      <v-btn
                        class="text-capitalize"
                        @click="isActive.value = false"
                      >
                        Fechar
                      </v-btn>

                      <v-spacer></v-spacer>

                      <v-btn
                        class="text-capitalize"
                        color="red-darken-3"
                        variant="tonal"
                        @click="handleRemoveCollaborator(item.userId)"
                      >
                        Remover
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </template>
              </v-dialog>
            </div>
          </template>

          <template v-slot:no-data> Não há nenhum colaborador </template>

          <template v-slot:loading>
            <v-skeleton-loader type="table-row@10"></v-skeleton-loader>
          </template>
        </v-data-table>

        <ItemsPerPage
          class="mt-15"
          :total_pages="pagination.totalPages"
          :total_items="pagination.totalElements"
          @update:pagination="(pagination: Pagination) => handleUpdatePageProps(pagination)"
        />
      </div>
    </div>
  </v-card>
</template>

<script lang="ts">
import { defineComponent, onMounted, Ref, ref } from "vue";

import { useLoadingDialog } from "@/stores/loading.store";

import { useUser } from "@/composables/useUser";

import PageTitle from "@/components/Common/PageTitle.vue";

import ItemsPerPage from "@/components/Common/ItemsPerPage.vue";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
import type { Pagination } from "@/types/props/pagination";
import { useAuthStore } from "@/stores/auth.store";

export default defineComponent({
  name: "CollaboratorsPage",
  components: {
    PageTitle,
    ItemsPerPage,
  },
  setup() {
    const authStore = useAuthStore();
    const loadingStore = useLoadingDialog();

    const { columns, pagination, users, getAllCollaborators, deleteUserById } =
      useUser();

    const user: Ref = ref(authStore.getUser);

    const isLoadingUserCollaborators = ref(false);

    const fetchUserCollaboratorsData = async () => {
      try {
        isLoadingUserCollaborators.value = true;

        getAllCollaborators(
          pagination.value.currentPage,
          pagination.value.totalPerPage
          // user.value.userId
        ).then(() => {
          isLoadingUserCollaborators.value = false;
        });
      } catch (error) {
        console.error("Erro ao buscar dados de colaboradores:", error);
      }
    };

    const handleRemoveCollaborator = async (user_id: number) => {
      loadingStore.setLoading("Removendo colaborador...");

      await deleteUserById(user_id);

      loadingStore.setLoadingOff();
    };

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleUpdatePageProps = async ({ page, size }: any) => {
      pagination.value.currentPage = page;
      pagination.value.totalPerPage = size;

      await fetchUserCollaboratorsData();
    };

    onMounted(async () => {
      await fetchUserCollaboratorsData();
    });

    return {
      user,
      columns,
      pagination,
      isLoadingUserCollaborators,
      users,
      handleUpdatePageProps,
      handleRemoveCollaborator,
    };
  },
});
</script>
